import esContent from './domainRegister.es';

export default {
  ...esContent,
};
